import { render } from "./DashboardLink.vue?vue&type=template&id=0743ac55"
import script from "./DashboardLink.vue?vue&type=script&lang=js"
export * from "./DashboardLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__